/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import { useAuthGlobal } from "../../../../../contexts/auth-context/auth-context";

import { CNAESModel } from "../../../../../domain/models/cnae";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";

import InvoiceForm from "../../../../../presentation/pages/developer/invoice/form";

import toastUtils from "../../../../../utils/ToastUtils";
import { getErrorMessage } from "../../../../../presentation/helpers";

import { makeRemoteCNAES } from "../../../usecases/cnaes/remote-cnaes-factory";
import { makeRemoteDeveloperCompanies } from "../../../usecases/developer-companies/remote-developer-companies-factory";
import { makeRemoteInvoice } from "../../../usecases/invoice/remote-invoice-factory";

const MakeInvoice: React.FC = () => {
  const [developerCompaniesList, setDeveloperCompaniesList] = React.useState<
    DeveloperCompanyModel[]
  >([]);

  const [cnaesList, setCnaesList] = React.useState<CNAESModel[]>([]);

  const { user } = useAuthGlobal();

  React.useEffect(() => {
    (async () => {
      const econ = await makeRemoteDeveloperCompanies().getByDeveloper();
      setDeveloperCompaniesList(econ);
    })();
  }, []);

  React.useEffect(() => {
    (async () => {
      const econ = await makeRemoteCNAES().loadAll({
        query: user?.developerResponseDTO?.address?.city?.id,
      });
      setCnaesList(econ);
    })();
  }, []);

  const handleSubmit = async (
    values: any,
    setShowConfirm: any,
    setShowPreview: any,
  ): Promise<void> => {
    try {
      setShowConfirm(true);
      await makeRemoteInvoice().create({
        addressName: values?.address,
        bankAccount: values?.bankAccount,
        bankAgency: values?.bankAgency,
        bankDigit: values?.bankDigit,
        bankName: values?.bankName,
        city: values.city,
        companyName: values?.companyName,
        currency: {
          id: Number(values?.currency?.split(" - ")[3]),
        },
        developerCompany: {
          id: developerCompaniesList.find(
            (item) => item?.company?.id === values?.company,
          )?.id as number,
        },
        nation: values?.country?.name,
        postalCode: values?.postalCode,
        serviceDescription: values?.description,
        state: values?.state,
        total: Number(
          values?.serviceValue.replaceAll(".", "").replaceAll(",", "."),
        ),
      });
      setTimeout(() => {
        setShowConfirm(false);
        setShowPreview(true);
      }, 6000);
      toastUtils.showMessage({
        type: "success",
        message:
          "Gerado com Sucesso! Aguarde 5 minutos para que a sua nota esteja disponível para download",
      });
    } catch (error: any) {
      setShowConfirm(false);

      const message = getErrorMessage(error);
      toastUtils.showMessage({
        type: "error",
        message,
      });
    }
  };

  return (
    <InvoiceForm
      loading={false}
      handleSubmit={handleSubmit}
      cnaesList={cnaesList}
      developerCompaniesList={developerCompaniesList}
    />
  );
};

export default MakeInvoice;
